export default __webpack_public_path__ + "813645bfbe6d696b940597121c8b4492.ttf";